import * as React from 'react';
function mergeRefs(...refs) {
    return (node) => {
        refs.forEach((ref) => {
            if (typeof ref === 'function') {
                ref(node);
            }
            else if (ref) {
                ref.current = node;
            }
        });
    };
}
export function useMergeRefs(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return React.useMemo(() => mergeRefs(...refs), refs);
}
